import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { isUpdateAvailable, reloadForUpdate, subscribeVersionUpdate } from '@frontend-shared/assets'

// Shows a "new version available" banner and auto-reloads at a safe moment.
// Safe moment = the next in-app navigation after an update was detected (we are leaving the
// current view anyway). On a page the user stays on, the banner offers a manual refresh.
export default function UpdateBanner() {
  const { t } = useTranslation()
  const location = useLocation()
  const [available, setAvailable] = useState(() => isUpdateAvailable())
  const firstNavigationRef = useRef(true)

  useEffect(() => subscribeVersionUpdate(() => setAvailable(isUpdateAvailable())), [])

  useEffect(() => {
    if (firstNavigationRef.current) {
      firstNavigationRef.current = false
      return
    }
    if (isUpdateAvailable()) {
      reloadForUpdate()
    }
  }, [location.pathname])

  if (!available) {
    return null
  }

  return (
    <div className="update-toast" role="status" aria-live="polite">
      <span>{t('app.update.available')}</span>
      <button type="button" onClick={() => window.location.reload()}>
        {t('app.update.refresh')}
      </button>
    </div>
  )
}
